import Cookies from 'js-cookie';

export const saveCookie = (name: string, value: string) => {
  Cookies.set(name, value, { expires: 7, path: '/' });
};

export const getCookie = (name: string) => {
  return Cookies.get(name);
};